import view from '../../view';
import getBlockByElement from './get-block-by-element';

const getBlockByElementId = (elementId) =>
  getBlockByElement(view.accessors.getLiveElement(elementId));

export default getBlockByElementId;
